module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    ref: "tooltip",
    staticClass: "ci-action-icon-wrapper js-ci-status-icon",
    attrs: {
      "data-method": _vm.actionMethod,
      "title": _vm.tooltipText,
      "href": _vm.link,
      "rel": "nofollow",
      "data-toggle": "tooltip",
      "data-container": "body",
      "aria-label": "Job's action"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.actionIconSvg)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/~/vue-loader/lib/template-compiler?{"id":"data-v-64d2a686"}!/home/git/gitlab/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/dropdown_action_component.vue
// module id = L3NB
// module chunks = 6